import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, CircularProgress, Alert, Typography } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'

export default function ResultStep({ loading, result, error, onClose }) {
  const { t } = useTranslation()

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        p={4}
        gap={2}
      >
        <CircularProgress />
        <Typography>{t('calendar-import.result-loading')}</Typography>
      </Box>
    )
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      p={4}
      gap={3}
    >
      {error ? (
        <Alert severity="error" sx={{ width: '100%' }}>
          {t('calendar-import.result-error')}
        </Alert>
      ) : (
        <>
          <CheckCircleOutlineIcon color="success" sx={{ fontSize: 56 }} />
          <Typography variant="h6" color="success.main">
            {t('calendar-import.result-success', {
              count: result?.created ?? 0,
            })}
          </Typography>
        </>
      )}
      <Button variant="contained" onClick={onClose}>
        {t('calendar-import.result-close')}
      </Button>
    </Box>
  )
}
